import { render } from "./DatasourceEDAVariableDetail.vue?vue&type=template&id=98bac8b4&scoped=true&ts=true"
import script from "./DatasourceEDAVariableDetail.vue?vue&type=script&lang=ts"
export * from "./DatasourceEDAVariableDetail.vue?vue&type=script&lang=ts"

import "./DatasourceEDAVariableDetail.vue?vue&type=style&index=0&id=98bac8b4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98bac8b4"]])

export default __exports__